import React from 'react'
import { Classes } from '@blueprintjs/core'
import { HighlightedText, IUIButtonProps } from '..'
import { IWorkplaceGroup } from '@api/types'
import api from '@api'
import GenericSelectWithInfiniteScroll, {
  SelectProps,
  ItemProps,
} from './GenericSelectWithInfiniteScroll'
import ColorSquare from '@ui/ColorSquare'

type WPGSelectProps = SelectProps<IWorkplaceGroup>

export default function WPGSelect(
  props: WPGSelectProps & {
    canCreate?: boolean
    onCreate?: (param: string) => void
    buttonProps?: IUIButtonProps
  }
) {
  return (
    <GenericSelectWithInfiniteScroll<IWorkplaceGroup>
      {...props}
      canCreate={props.canCreate}
      onCreate={props.onCreate}
      list={api.workplaceGroup.search}
      Item={WorkplaceGroupItem}
      buttonProps={props.buttonProps}
    />
  )
}

export function WorkplaceGroupItem({ type, data, refItem, query }: ItemProps<IWorkplaceGroup>) {
  if (type === 'skeleton') {
    return (
      <div className="flex items-center py-1" style={{ minWidth: 300 }}>
        <ColorSquare skeleton />
        <div className="ml-2">
          <span className={Classes.SKELETON}>workplaceGroup name</span>
        </div>
      </div>
    )
  }

  const { name, color } = data as IWorkplaceGroup

  return (
    <div ref={refItem} className="flex items-center py-1 truncate">
      <ColorSquare style={{ background: `#${color}` }} />
      <div className="ml-2 font-medium truncate">
        <HighlightedText query={query} text={name} />
      </div>
    </div>
  )
}
